import { c as _c } from "react/compiler-runtime";
import { UserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import React, { ReactNode } from 'react';
import { Button, Modal } from 'shared/components';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface UpgradePlanConfirmationModalProps {
  pricePlan: UserPlanInterface;
  paymentPageUrl: string;
  cost: string;
  isPlanUpgradeAvailable?: boolean;
  opened: boolean;
  onOpen: () => void;
  onClose: () => void;
  afterModalClose?: () => void;
  isFetching: boolean;
  error: string;
  onConfirm: () => void;
  /** Overrides the default confirm form, e.g. a processor-specific waiting state. */
  content?: ReactNode;
}
const UpgradePlanConfirmationModal = t0 => {
  const $ = _c(32);
  const {
    pricePlan,
    paymentPageUrl,
    cost,
    isPlanUpgradeAvailable,
    opened,
    onOpen,
    onClose,
    afterModalClose,
    isFetching,
    error,
    onConfirm,
    content
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = !isPlanUpgradeAvailable;
  let t2;
  if ($[0] !== pricePlan.title) {
    t2 = pricePlan.title.toLowerCase();
    $[0] = pricePlan.title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `button-plan-${t2}-upgrade`;
  let t4;
  if ($[2] !== t) {
    t4 = t("dashboard.settings.user_plan.upgrade_plan_title");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <strong className="truncate">{t4}</strong>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onOpen || $[7] !== t1 || $[8] !== t3 || $[9] !== t5) {
    t6 = <Button onClick={onOpen} disabled={t1} data-test-id={t3} variant="primary" size="sm">{t5}</Button>;
    $[6] = onOpen;
    $[7] = t1;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("dashboard.settings.user_plan.upgrade_confirmation_title");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== content || $[14] !== cost || $[15] !== error || $[16] !== isFetching || $[17] !== onClose || $[18] !== onConfirm || $[19] !== paymentPageUrl || $[20] !== t) {
    t8 = content ?? <form className="flex flex-col gap-6"><div className="flex flex-col items-center justify-center gap-1"><div>{t("dashboard.settings.user_plan.upgrade_price_title")}: {cost}</div><div className="flex">{t("dashboard.settings.user_plan.upgrade_confirmation_text")}</div></div><div className="tablet:[&>*]:flex-none tablet:[&>*]:w-auto flex justify-end gap-3 [&>*]:flex-1"><Button onClick={e => {
          e.preventDefault();
          onClose();
        }} disabled={isFetching} variant="secondary" size="md">{t("confirmation_modal.cancel")}</Button><Button onClick={async e_0 => {
          e_0.preventDefault();
          onConfirm();
        }} type="submit" isLoading={isFetching} data-test-id="confirm-plan-upgrade" variant="primary" size="md">{t("confirmation_modal.confirm")}</Button></div><div className="flex justify-center"><a href={paymentPageUrl} className="text-text-link aria-disabled:pointer-events-none aria-disabled:opacity-50" aria-disabled={isFetching} target="_self">{t("dashboard.settings.user_plan.upgrade_change_payment_method_title")}</a></div><FieldErrorAndDescription error={error} errorClassName="text-center mt-2" /></form>;
    $[13] = content;
    $[14] = cost;
    $[15] = error;
    $[16] = isFetching;
    $[17] = onClose;
    $[18] = onConfirm;
    $[19] = paymentPageUrl;
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== afterModalClose || $[23] !== isFetching || $[24] !== onClose || $[25] !== opened || $[26] !== t7 || $[27] !== t8) {
    t9 = <Modal opened={opened} onClose={onClose} title={t7} afterLeave={afterModalClose} isFetching={isFetching}>{t8}</Modal>;
    $[22] = afterModalClose;
    $[23] = isFetching;
    $[24] = onClose;
    $[25] = opened;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t6 || $[30] !== t9) {
    t10 = <>{t6}{t9}</>;
    $[29] = t6;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};
export default UpgradePlanConfirmationModal;